module.exports = __webpack_public_path__ + "img/flag_be.df57b33a.svg";